import { ARIA_HIDDEN, TRANSPARENT_CLASS } from 'views/assets/scripts/consts'
import toggleBoolStringAttr from 'views/utils/toggleBoolStringAttribute'
import {
  MODAL_CONTENT_SELECTOR,
  VIDEO_TRANSITION_CLASS,
  VIDEO_CONTAINER_SELECTOR,
  VIDEO_SELECTOR,
  VIDEO_SLIDE_DATA_SELECTOR,
  VIDEO_THUMBNAIL_SELECTOR
} from './consts'

/**
 * Used in both `Slider` and `Modal` classes to control the videos.
 *
 * @class
 * @constructor
 * @public
 */
export default class Video {
  constructor() {
    this.activeVideoElement = null
  }

  /**
   * Starts playing passed video element
   *
   * @param {HTMLElement} videoElement - Element that will be played
   * @returns {void}
   */
  play = videoElement => {
    /** @type HTMLElement */
    const thumbnail = videoElement.querySelector(VIDEO_THUMBNAIL_SELECTOR)
    const video = videoElement.querySelector(VIDEO_SELECTOR)

    toggleBoolStringAttr(thumbnail, ARIA_HIDDEN, true)

    const playPromise = video.play()

    if (playPromise instanceof Promise) {
      playPromise.catch(() => video.play())
    }

    this.activeVideoElement = videoElement
  }

  /**
   * Pauses the video in slider
   *
   * @returns {void}
   */
  pause = () => {
    if (!this.activeVideoElement) {
      return
    }

    /** @type HTMLElement */
    const thumbnail = this.activeVideoElement.querySelector(
      VIDEO_THUMBNAIL_SELECTOR
    )
    const video = this.activeVideoElement.querySelector(VIDEO_SELECTOR)

    toggleBoolStringAttr(thumbnail, ARIA_HIDDEN, false)
    video.pause()
    video.load()

    this.activeVideoElement = null
  }

  playVideo = (ctx, index) => {
    const modalContent = document.querySelector(MODAL_CONTENT_SELECTOR)
    modalContent.classList.add(TRANSPARENT_CLASS)

    // FIXME: we should get rid of this timeout OR at least decrease the time
    return new Promise(resolve =>
      setTimeout(() => {
        const slider = ctx.isLargeViewport ? ctx.modalSlider : ctx.majorSlider
        if (slider) {
          slider.goTo(index)
          const { slideItems } = slider.getInfo()
          const current = slideItems[index].querySelector(
            VIDEO_CONTAINER_SELECTOR
          )
          this.play(current)
          resolve({ slider, current })

          setTimeout(() => {
            modalContent.classList.add(VIDEO_TRANSITION_CLASS)
            modalContent.classList.remove(TRANSPARENT_CLASS)
          }, 300)
        }
      }, 450)
    )
  }

  /**
   * Checks if current slide is video
   *
   * @param {Object} info Info object from tiny slider
   * @param {Object[]} info.slideItems
   * @param {number} info.index
   * @returns {boolean}
   */
  isCurrentSlideVideo = info => {
    const { slideItems, index } = info
    const slideHook = slideItems[index].dataset.clientsideHook
    const slideIsVideo = slideHook === VIDEO_SLIDE_DATA_SELECTOR

    return slideHook ? slideIsVideo : false
  }
}
